// extracted by mini-css-extract-plugin
module.exports = {"zIndexToolTip":"13380000","magicBanner":"styles_magicBanner__2Ltg8","magicBannerText":"styles_magicBannerText__i57VF","magicBannerButtons":"styles_magicBannerButtons__1DCEd"};